import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spin } from "antd";
import React, { FC } from "react";

export const LoadingOverlay: FC<{ isLoading?: boolean }> = ({ isLoading }) => {
  // To use this loading overlay use below code:
  // const setIsLoading = useSetAtom(loadingOverlayAtom) 
  // and import the loadingOverlayAtom from _app.tsx
  // you need to setIsLoading(true) to display and set it to false to hide the loading overlay 

  if(!isLoading) {
    return <></>
  }
  
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999] w-screen h-screen">
      <Spin indicator={<FontAwesomeIcon icon={faCircleNotch} spin color={'#133E87'} style={{fontSize: 50}} />} />
    </div>
  );
};